import ReportMonth from './ReportMonth';
import ReportRange from './ReportRange';

export default {
  report_month: ReportMonth,
  report_range: ReportRange
};
